export const SET_LOOKUPS = 'SET_LOOKUPS'
export const RESET_LOOKUPS = 'RESET_LOOKUPS'
export const UPSERT_LOOKUP = 'UPSERT_LOOKUP'
export const DELETE_LOOKUP = 'DELETE_LOOKUP'
export const SET_GROUPS = 'SET_GROUPS'
export const UPSERT_GROUP = 'UPSERT_GROUP'
export const SET_TIMEZONES = 'SET_TIMEZONES'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_STATE_PROVINCES = 'SET_STATE_PROVINCES'
export const SET_LANGUAGES = 'SET_LANGUAGES'
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE'
export const SET_CALIBRATE_READY = 'SET_CALIBRATE_READY'
export const SET_CALIBRATE_PRECHECKLIST = 'SET_CALIBRATE_PRECHECKLIST'
export const SET_CALIBRATE_SERVICE = 'SET_CALIBRATE_SERVICE'
export const SET_CALIBRATE_ACTIONTYPE = 'SET_CALIBRATE_ACTIONTYPE'
export const SET_CALIBRATE_VERIFY = 'SET_CALIBRATE_VERIFY'
export const SET_CALIBRATE_LISTS = 'SET_CALIBRATE_LISTS'
export const CHANGE_SORT = 'CHANGE_SORT'



// WEBPACK FOOTER //
// ./src/store/modules/lookups/types.js